<template>
    <b-container fluid class="animated fadeIn">
        <h1>Relatório Protesto-Ajuizamento</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div>
                        <b-card class="primary-semi p-2">
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="Período:" label-for="periodoInicial" class="text-label">
                                        <b-form-input type="date" v-model="filtro.periodoInicial"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group label="a" label-for="periodoFinal" class="text-label">
                                        <b-form-input type="date" v-model="filtro.periodoFinal"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group
                                            label="Tipo de Crédito:"
                                            label-for="tiposCredito"
                                            class="text-label">
                                        <multiselect
                                                name="tiposCredito"
                                                v-model="filtro.tiposCredito"
                                                :show-labels="false"
                                                :options="dados.tiposCredito"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="nome"
                                                :disabled="!dados.tiposCredito.length">
                                        </multiselect>
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                    <b-form-group
                                            label="Tipo do Relatório:"
                                            label-for="tipoRelatorio"
                                            class="text-label">
                                        <multiselect
                                                name="tipoRelatorio"
                                                v-model="filtro.tipoRelatorio"
                                                :show-labels="false"
                                                :options="dados.tiposRelatorio"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="nome" >
                                        </multiselect>
                                    </b-form-group>
                                </b-col>
                                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                                    <b-form-group label="Tipo de Arquivo:" label-for="tipoArquivo" class="text-label">
                                        <b-form-radio-group
                                            v-model="filtro.tipoArquivo"
                                            :options="dados.tiposArquivo"
                                            name="tipoArquivo"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row class="justify-content-center">
                                <div class="d-flex justify-content-between mb-3">
                                    <div>
                                        <b-button variant="primary" class="fonte-branca ml-2" @click="gerarRelatorio" :disabled="filtro.tipoRelatorio == null">
                                            <i class="fa fa-file-pdf-o" v-if="!loadCSV"></i>
                                            <b-spinner small v-if="loadCSV"></b-spinner>
                                            Gerar Relatório
                                        </b-button>
                                        <b-button class="mx-1" variant="secondary" @click="voltar">
                                            <i class="fa fa-reply"></i> Voltar
                                        </b-button>
                                    </div>
                                </div>
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
    import axios from 'axios/index';

    export default {
        name: 'RelatorioProtestoAjuizamento',
        components: { },
        data() {
            return {
                filtro: {
                    periodoInicial: null,
                    periodoFinal: null,
                    tiposCredito: [],
                    tipoRelatorio: null,
                    tipoArquivo: 0
                },
                dados: {
                    tiposCredito: [],
                    tiposRelatorio: [{
                        id: 0,
                        nome: 'Relatório de CDA\'s Protestadas/Ajuizadas'
                    },{
                        id: 1,
                        nome: 'Relatório de Execuções Fiscais'
                    }],
                    tiposArquivo: [
                        { text: 'PDF', value: 0 },
                        { text: 'XLS', value: 1 },
                        { text: 'CSV', value: 2 }
                    ]
                },
                ambiente: process.env.VUE_APP_BRY_AMBIENTE,
                token: JSON.parse(this.$store.getters.getUser).access_token,
                loadCSV: false
            }
        },
        methods: {
            async gerarRelatorio() {
                this.loadCSV = true;

                const urlApi = process.env.VUE_APP_ROOT_API;
                const token = JSON.parse(this.$store.getters.getUser).access_token;

                const payload = {
                    ...this.filtro,
                    tipoRelatorio: this.filtro.tipoRelatorio.id
                }

                await axios.post(`${urlApi}/v1/relatorioProtestoAjuizamento/gerarRelatorio`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    },
                    responseType: 'arraybuffer'
                })
                .then( (response) => {
                     if(!response.data || !response.data.byteLength){
                        this.$store.commit("setMessages", { message: 'Erro!', errors: ['Não há Dívidas dentro dos parâmetros informados.'] });
                        return;
                    }

                    const nomeArquivo = this.filtro.tipoRelatorio.id == 0 ? 'relatorio-protesto-ajuizamento' : 'relatorio-execucoes-fiscais';

                    if (this.filtro.tipoArquivo == 0) {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = nomeArquivo + '.pdf';
                        link.click();
                    } else if (this.filtro.tipoArquivo == 1) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nomeArquivo + '.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    } else if (this.filtro.tipoArquivo == 2) {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nomeArquivo + '.csv');
                        document.body.appendChild(link);
                        link.click();
                    }
                }).finally(() => {
                    this.loadCSV = false
                })
            },

            async listarTipoCredito() {
                const urlApi = process.env.VUE_APP_ROOT_API

                axios.get(`${urlApi}/v1/consultarCdas/listarTipoCredito`)
                    .then(response => {
                    this.dados.tiposCredito = response.data
                })
            },

            /**
             * Volta para a dashboard
             */
            voltar() {
                this.$router.push('/dashboard');
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.listarTipoCredito();
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .fonte-branca {
        color: #FFF;
    }

    .fonte-branca:hover {
        color: #FFF;
    }

    .fonte-branca:active {
        color: #FFF !important;
    }
</style>